// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../utils/axiosInstance";
// import CryptoJS from "crypto-js";  // Import crypto-js

// // Encryption key - use a secure key in a production environment
// const encryptionKey = "asdfasdfasdfasdfasdfasdfasdfasdfasdfas";

// const encrypt = (data) => {
//     return CryptoJS.AES.encrypt(JSON.stringify(data), encryptionKey).toString();
// };

// const decrypt = (data) => {
//     const bytes = CryptoJS.AES.decrypt(data, encryptionKey);
//     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
// };

// export const loginApi = createAsyncThunk('login', async (values) => {
//     const response = await axiosInstance.post('/login', {
//         email: values.email,
//         password: values.password,
//     });
//     return response.data;
// });

// const loginSlice = createSlice({
//     name: "login",
//     initialState: {
//         login: [],
//         errors: [],
//         loading: false
//     },
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             .addCase(loginApi.pending, (state) => {
//                 state.loading = true;
//             })
//             .addCase(loginApi.fulfilled, (state, action) => {
//                 state.login = action.payload;
//                 state.loading = false;
//             })
//             .addCase(loginApi.rejected, (state, action) => {
//                 state.errors = action.payload;
//                 state.loading = false;
//             });
//     }
// });

// export default loginSlice.reducer;

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import axios from "axios";
import axiosInstanceMainUrl from "../../utils/axiosInstanceMainUrl";

export const loginApi2 = createAsyncThunk(
  "login2",
  async ({ url, values }, { rejectWithValue }) => {
    // console.log("URL==============>>>", url)
    try {
      const response = await axiosInstanceMainUrl.post(url, values);
      // const response = await axios.post(url, values);
      if (response.data?.error) {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (err) {
      return rejectWithValue({
        error: true,
        message: err.response?.data?.message || "API Failed",
      });
    }
  },
);

const loginSlice2 = createSlice({
  name: "login2",
  initialState: {
    login: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginApi2.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginApi2.fulfilled, (state, action) => {
        state.login = action?.payload;
        state.loading = false;
      })
      .addCase(loginApi2.rejected, (state, action) => {
        state.errors = action.payload;
        // state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default loginSlice2.reducer;
